import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdModal, CmdModalFooterButton } from '@commander-services/gui-components';
import TooltipComponent from '../TooltipComponent';

interface IOption {
  item: string;
  value: string;
  passed: boolean;
  vehicles: number;
  total: number;
  disabled: boolean;
  popup: string | null;
}

interface IVehicleGroupFormProps {
  closeCallback: () => void;
  selectedItems: string[];
  options: {
    [key: string]: IOption[];
  };
}

function VehicleGroupListForm(props: IVehicleGroupFormProps): JSX.Element {
  const { formatMessage: f } = useIntl();

  const buttons: CmdModalFooterButton[] = [
    {
      id: 'close-modal',
      type: 'button',
      className: 'e-button',
      title: f({ id: 'alarms.modal.rule.button.close' }),
      closeCallback: props.closeCallback,
    },
  ];

  const getData = () => {
    if (props.options && props.selectedItems) {
      let ids: string[] = [];
      props.selectedItems.forEach((item) => {
        ids = ids.concat(item);
      });
      let optionsArr: IOption[] = [];
      Object.values(props.options).forEach((item: IOption[]) => {
        optionsArr = optionsArr.concat(item);
      });
      const data = optionsArr.filter((i: IOption) => ids.includes(String(i.value)));
      return data;
    }
    return [];
  };

  return (
    <CmdModal
      id="vehiclegrouplist-form-modal"
      title={f({ id: 'alarms.modal.vehicleGroups.title' })}
      footerButtons={buttons}
      data-cy="vehiclegrouplist-form-modal"
    >
      <div className="filtered-list">
        {getData().map((item: IOption) => (
          <div
            key={item.value}
            style={{
              padding: '10px 16px',
              color: '#555',
            }}
            className="filtered-item"
            data-cy={`vehicle-group-item-${item.value}`}
          >
            {item.item} &nbsp;
            {Number(item.vehicles) > -1 && Number(item.total) > -1 ? (
              <span data-cy="information-vehicle-group">
                ({item.vehicles}/{item.total})&nbsp;
              </span>
            ) : (
              <span />
            )}
            {item.passed === false &&
              (item.popup ? (
                <TooltipComponent
                  id="vehicle-group"
                  display="inline"
                  firstItems={true}
                  overlay={<div style={{ color: '#fff' }}>{item.popup}</div>}
                  key="err"
                  data-cy={`tooltip-vehicle-group-${item.value}`}
                >
                  <i
                    id={`icon-${item.value}`}
                    className="cmd-icon cmd-icon-exclamation text-primary"
                    data-cy={`tooltip-icon-vehicle-group-${item.value}`}
                  />
                </TooltipComponent>
              ) : (
                <i
                  id={`icon-${item.value}`}
                  className="cmd-icon cmd-icon-exclamation text-primary"
                  data-cy={`icon-vehicle-group-${item.value}`}
                />
              ))}
          </div>
        ))}
        <div style={{ height: '24px' }} />
      </div>
    </CmdModal>
  );
}

export default VehicleGroupListForm;
